import script from "./footer1.vue?vue&type=script&setup=true&name=footer1&lang=js"
export * from "./footer1.vue?vue&type=script&setup=true&name=footer1&lang=js"

const __exports__ = script;

export default __exports__